import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective, TranslocoModule } from '@jsverse/transloco';
import { TranslocoService } from '@jsverse/transloco';
import { MapComponent } from '../../maps/maps';

@Component({
  selector: 'app-index',
  standalone: true,
  imports: [RouterLink, TranslocoModule, TranslocoDirective, MapComponent ],
  templateUrl: './index.html',
  styleUrl: '../../../styles.css',
})
export class IndexComponent {
  public totalInIndex: number = 0;
  
  constructor(
    private readonly translocoService: TranslocoService
  ) {}

  setTotal(valor: number) {
    this.totalInIndex = valor; 
  }

  changelanguage(lang: string) {
    this.translocoService.setActiveLang(lang);
  }
  
}
